export default __webpack_public_path__ + "static/media/saraimg.19a68bde.jpg";